import { mapGetters, mapState } from 'vuex'

export default
{
	computed:
	{
		...mapState
		(
			{
				accounts: state => state.accounts.accounts,
			}
		),

		...mapGetters([ 'hasAccounts' ]),
	},
}